<template>
    <div class="index">
        
        <div class="title">
            <img src="../../assets/images/register/logo.png" alt="">
            恋TA用户邀请注册
        </div>
        <div class="input">
            <img src="../../assets/images/register/icon05.png" alt="">
            <van-cell-group>
                <van-field v-model="person" label="" placeholder="邀请人" disabled/>
            </van-cell-group>
        </div>
        <div class="input">
            <img src="../../assets/images/register/icon06.png" alt="">
            <van-cell-group>
                <van-field v-model="phone" label="" placeholder="请输入手机号码" maxlength="11"/>
            </van-cell-group>
        </div>
        <div class="input">
            <img src="../../assets/images/register/icon07.png" alt="">
            <div class="input-c">
                <van-cell-group>
                <van-field v-model="code" label="" placeholder="请输入验证" maxlength="6"/>
                </van-cell-group>
            </div>
            <div class="gecode" @click="captchaButtonClick">
                {{captchaFont}}
            </div>
        </div>

        <div :class="code?'btn-this':'btn'" @click="login">
            立即注册
        </div>


        <div class="main-bottom">
                    
            <div class="bottom-center">
                <div class="bottom-center-item">
                    长沙伊人科技有限公司 版权所有
                </div>
                <div class="bottom-center-item">
                    <img src="../../assets/images/icon08.png" alt="">
                    <div class="bottom-center-item-i">
                        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43010502001442"><img src=""/><p>湘公网安备 43010502001442号</p></a>
                    </div>
                </div>
                <div class="bottom-center-item">
                    <!-- 湘公网安备43010502001442号 -->
                    <a href="https://beian.miit.gov.cn/">
                        湘ICP备2022007549号
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../api/login'
import { Dialog,Toast} from 'vant';
import {isPhoneNumber} from '../../utils/index'

export default {
    name: 'index', 
    components: {
    },
    data () {
        return {
            person:this.$route.query.nickName+'(邀请人)',
            phone:'',
            recommenderId:this.$route.query.userId,
            code:'',
            captchaFont: '获取验证码',
            totalTime: 60,
            timer: null,
            rulesText: '',
            regCodeText:'',
        }
    },
    watch:{
        
    },
    created(){
        
        document.title="恋TA官网_一款真人认证、安全私密的真人约玩APP"
    },
    mounted(){
        
    },
    methods:{
        async captchaButtonClick() {
            if(!isPhoneNumber(this.phone)){
                Toast({message: '注册账号不是手机号!'});
                return;
            }
            if (this.captchaFont != '获取验证码') return
            if (this.phone) {
            if (isPhoneNumber(this.phone)) {
                let res = await api.sendCode(this.phone);
                if(res.data.code == '200'){
                    this.regCodeText = res.data.Msg
                    this.countdown();
                }
            } else {
                
            }
            } else {
                
            }
        },
        // 倒计时
        countdown() {
            this.captchaFont = this.totalTime + '秒'
            this.timer = window.setInterval(() => {
            this.totalTime--
            this.rulesText = '验证码已发送'
            if (this.totalTime !== 0) {
                this.captchaFont = this.totalTime + '秒'
            } else {
                this.cleanTimer()
            }
            }, 1000)
        },
        cleanTimer() {
            window.clearInterval(this.timer)
            this.totalTime = 60
            this.captchaFont = '获取验证码'
            this.rulesText = ''
        },
        async login(){
            let res = await api.register({
                phone:this.phone,
                code:this.code,
                recommenderId:this.recommenderId,
            });
            if(res.data.code == '200'){

                Dialog.confirm({
                    title: '提示',
                    message:
                        '注册成功，请于官网立即下载',
                    })
                .then(() => {
                    
                    this.$router.push({
                        name:'mindex'
                    })
                })
                .catch(() => {
                });
                
            }else{
                Toast({message: res.data.msg});
            }
        },
    }
  
}
</script>

<style lang="scss" scoped>
    /deep/.van-hairline--top-bottom::after, /deep/.van-hairline-unset--top-bottom::after{
        border: 1px solid #ffffff;
    }
    .index{
        height: 100%;
        .title{
            display: flex;
            align-items: center;
            font-size: 18px;
            letter-spacing: 1px;
            font-weight: bold;
            justify-content: center;
            padding-top: 20px;
            margin-bottom: 25px;
            img{
                width: 33px;
                height: 33px;
                margin-right: 13px;
            }
        }
        .input{
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #eeeeee;
            width: 310px;
            margin: 0 auto;
            height: 50px;
            margin-top: 25px;
            /deep/.van-field__control:disabled{
                color: #222222;
                -webkit-text-fill-color: #222222;
            }
            .input-c{
                width: 116px;
            }
            img{
                width: 25px;
                height: 25px;
            }
            /deep/input{
                font-size: 15px;
            }
            .gecode{
                width: 100px;
                font-size: 15px;
                text-align: center;
            }
        }
        .btn{
            width: 310px;
            height: 50px;
            margin: 0 auto;
            margin-top: 70px;
            color: #ffffff;
            background-color: #e5e5e5;
            border-radius: 25px;
            font-size: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .btn-this{
            width: 310px;
            height: 50px;
            margin: 0 auto;
            margin-top: 70px;
            color: #ffffff;
            background-image: linear-gradient(to right,#c1c2ed, #fed1f2);
            border-radius: 25px;
            font-size: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .main-bottom{
            padding-top: 10px;
            width: 100%;
            background-color: #3a3d3d;
            margin-top: 50px;
            color: #FFFFFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-bottom: 15px;
            font-size: 13px;
            position: absolute;
            bottom: 0;
            span{
                margin: 0 10px;
            }
            a{
                color: #ffffff;
            }
            .bottom-center-item{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 5px;
                .bottom-center-item-i{
                    display: flex;
                    align-items: center;
                }
            }
            img{
                margin-right: 10px;
            }
        }
    }
    
</style>
